import React, { useEffect, useRef } from 'react';
import NavDock from '../Components/Layout/NavDock';
import Curve from '../Assets/Icons/Curve.svg';
import './Map.css'

import MapVid from '../Assets/Videos/map_Anim0001-1225.mp4'


const Map = () => {


    return (
        <div className="Map">
            <div className='TopBar'></div>
            
            
            <div className="MainMap" style={{ height: '100%', width: '100%' }}>
               <video src={MapVid} muted autoPlay></video>
            </div>
            <NavDock Curve={Curve} NotchClass='NotchCurve'/>
        </div>
    );
};

export default Map;